import { render, staticRenderFns } from "./rightNav.vue?vue&type=template&id=ed43d04e&"
import script from "./rightNav.vue?vue&type=script&lang=js&"
export * from "./rightNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports